import {type NavigationGuardNext, type RouteLocationNormalized} from 'vue-router';
import {useIntegrationStore} from "@domains/settings/stores/integration.store";
import {useWorkspaceStore} from "@shared/stores/workspace.store";
import {IntegrationNs} from "@shared/types";
import {isWsOwnerOrAdmin} from "@shared/mixins/role-manager";

export const getWorkspaceIntegrationResolver = async (
    to: RouteLocationNormalized,
    from: RouteLocationNormalized,
    next: NavigationGuardNext): Promise<void> => {

    const intStore = useIntegrationStore();
    const wsStore = useWorkspaceStore();
    const workspaceId = wsStore.getSelectedWorkspaceId;
    const payload = {workspaceId} as IntegrationNs.IntegrationInfoRequest;

    if(isWsOwnerOrAdmin()) {
        intStore.loadWorkspaceIntegrations(payload).then(() => next())
    } else {
        next()
    }

};
